<template>
	<div :class="['link-select', { 'check-select': isShow }]">
		<div class="choose" @click="check">
			<div class="circle" v-if="!isShow"></div>
			<i class="el-icon-success green" v-if="isShow"></i>
		</div>
		<div class="name">{{ titleName }}</div>
		<div class="link" v-if="fileName" @click="toskip">查看页面</div>
	</div>
</template>

<script>
export default {
	props: ['value','name', 'id', 'fileName','isCustom','showText'],
	data() {
		return {
			
		};
	},
	components: {},
	computed: {
		isShow() {
			let flag = this.value.some(item => {
				
				return this.id == item.pageId;
			});
			return flag;

		},
		queryParam() {
			return this.$route.query;
		},
		titleName()
		{
           return this.name?this.name:this.showText
		}

	},

	methods: {
		check() {
			let url ="";
			if(this.isCustom)
			{
				url=this.fileName;
			}else{
				 url = 'https://' + this.queryParam.name + '/' + this.fileName;
			}
			//或页面名称) 域名 页面ID 页面链接地址
			this.$emit("check",{content:this.name,domain:this.queryParam.name,pageId:this.id,pagePath:url})
		},
		toskip() {
			let url =this.isCustom?this.fileName:
				'https://' +
				this.queryParam.name+'/'+this.fileName;
			window.open(url);
		},
	},
	mounted() {},
};
</script>

<style lang="scss" scoped>
.link-select {
	display: flex;
	height: 40px;
	box-shadow: 0px 2px 8px 0px rgba(51, 51, 51, 0.15);
	border-radius: 4px;
	padding: 12px 20px;
	/* width: 20%; */
	cursor: pointer;
	.choose {
		display: flex;
		justify-content: flex-start;
		cursor: pointer;
		.circle {
			width: 16px;
			height: 16px;
			border: 1px solid #e9e9e9;
			border-radius: 8px;
		}
		.green {
			color: #34d04c;
			font-size: 16px;
		}
	}
	.link {
		font-size: 14px;
		color: #3da1ff;
	}

	.name {
		flex: 1;
		padding-left: 15px;
	}
}
.check-select {
	background: #ebf5ff;
}
</style>
